<template>
  <!--
    	作者：gmshop
    	时间：2019-10-26
    	描述：商品管理-商品添加
    -->
  <div class="product-add">
    <!--form表单-->
    <el-form size="small" ref="form" :model="form" label-width="180px">
      <div class="basic-setting-content pl16 pr16">
        <!--基本信息-->
        <div class="common-form">基本信息</div>
        <el-form-item label="发货单号：" :rules="[{ required: true, message: '请填写发货单号' }]" prop="model.order_no">
          <el-input v-model="form.model.order_no" class="max-w460"></el-input>
        </el-form-item>
        <el-form-item label="收货人姓名：" :rules="[{ required: true, message: '请填写收货人姓名' }]" prop="model.name">
          <el-input v-model="form.model.name" class="max-w460"></el-input>
        </el-form-item>
        <el-form-item label="收货人电话：" :rules="[{ required: true, message: '请填写收货人电话' }]" prop="model.phone">
          <el-input v-model="form.model.phone" class="max-w460"></el-input>
        </el-form-item>
        <el-form-item label="收货人地址：" :rules="[{ required: true, message: '请填写收货人地址' }]" prop="model.address">
          <el-input type="textarea" v-model="form.model.address" class="max-w460"></el-input>
        </el-form-item>
        <el-form-item label="用户ID" :rules="[{ required: true, message: '请选择用户ID' }]" prop="model.user_id" >
          <el-input type="text" v-model="form.model.user_id" autocomplete="off" class="max-w460">
          <el-button slot="append" type="primary" icon="el-icon-user-solid" @click="openUserDialog" >选择用户</el-button>
          </el-input>
        </el-form-item>
        <el-form-item label="取货属性：" :rules="[{ required: true, message: '请填写取货属性' }]" prop="model.pick_type">
          <el-radio-group v-model="form.model.pick_type">
            <el-radio :label="10">仓储取货</el-radio>
            <el-radio :label="20">指定地点取货</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="取货地址：" :rules="[{ required: true, message: '请输入取货地址' }]" prop="model.pick_address" v-if="form.model.pick_type==20">
          <el-input type="textarea" v-model="form.model.pick_address" class="max-w460"></el-input>
        </el-form-item>

      <!--用户选择-->
      <GetUser :is_open="open_user" @close="closeUserDialog"></GetUser>
      </div>

      <!--提交-->
      <div class="common-button-wrapper">
        <el-button size="small" type="info" @click="cancelFunc">取消</el-button>
        <el-button size="small" type="primary" @click="onSubmit" :loading="loading">发布</el-button>

      </div>
    </el-form>
  </div>
</template>

<script>
import DistributionApi from '@/api/distribution.js';
import GetUser from '@/components/user/GetUser.vue';
export default {
  components: {
    GetUser
  },
  data() {
    return {
      open_user: false,
      /*是否正在加载*/
      loading: false,
      /*form表单数据*/
      form: {
        model: {
          order_no:'',
          name:"",
          phone:"",
          address:'',
          user_id:'',
          pick_type:10,
        },

      }
    };
  },
  provide: function () {
    return {
      form: this.form
    }
  },
  created() {



  },
  methods: {





    /*提交*/
    onSubmit: function() {
      let self = this;
      let params = self.form.model;
      self.$refs.form.validate(valid => {
        if (valid) {
          self.loading = true;

          DistributionApi.addOrder({
            params: params
          }, true)
            .then(data => {
              self.loading = false;
              self.$message({
                message: '添加成功',
                type: 'success'
              });
              self.$router.push('/plus/distribution/order/index');
            })
            .catch(error => {
              self.loading = false;
            });
        }
      });
    },

    /*保存为草稿*/
    Draft() {
      let self = this;
      self.form.model.product_status = 30;
      self.onSubmit();
    },

    /*取消*/
    cancelFunc() {
      this.$router.back(-1);
    },
    /*打开用户弹窗*/
    openUserDialog() {
      this.open_user = true;
    },
    /*关闭用户弹窗*/
    closeUserDialog(e) {
      if (e.type != 'error') {
        this.user = e.params[0];
        this.form.model.user_id = e.params[0].user_id;
      }
      this.open_user = false;
    },

  }
};
</script>

<style lang="scss" scoped>
.basic-setting-content {
}

.product-add {
  padding-bottom: 100px;
}
</style>



// WEBPACK FOOTER //
// src/views/plus/distribution/order/add.vue